import { useSelector } from "react-redux"
import XuHuongDongTien from "./Trend/XuHuongDongTien";
import DetailBranch from "./Trend/DetailBranch";
import DetailCode from "./Trend/DetailCode";

import './Trend.scss'

export default function Trend() {
  const trend = useSelector((state: any) => state?.TrendStore);
  return (
    <>
      <div className="oPuJWzgnYo">
        {trend?.step === '' ? <XuHuongDongTien /> : null}
        {trend?.step === 'branch' ? <DetailBranch /> : null}
        {trend?.step === 'code' ? <DetailCode /> : null}
      </div>
    </>
  )
}